import { render, staticRenderFns } from "./AddMenu.vue?vue&type=template&id=5d40b9d8&scoped=true&"
import script from "./AddMenu.vue?vue&type=script&lang=js&"
export * from "./AddMenu.vue?vue&type=script&lang=js&"
import style0 from "./AddMenu.vue?vue&type=style&index=0&id=5d40b9d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d40b9d8",
  null
  
)

export default component.exports